import React from 'react'
import Tanggal from '../components/Tanggal'
import lightone from '../images/light1desk.webp'
import lighttwo from '../images/light2desk.webp'
import rzlfh from '../images/rzlfh-icon.svg'
import { motion } from "framer-motion"

const Hero = () => {

    return (
        <>
            <img src={lightone} alt="light 1" className='absolute bottom-0 left-0 w-[70%] md:w-[40%] -z-10' />
            <img src={lighttwo} alt="light 2" className='hidden md:block absolute right-0 top-0 w-[20%] -z-10' />

            <main className='grid place-content-center h-screen lg:grid-cols-6 text-center lg:text-left py-4 space-y-8 lg:space-y-12'>
                <motion.p
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{
                        ease: [0.6, 0.01, -0.05, 0.95],
                        duration: 1,
                        delay: 0.4,
                    }}
                    className='lg:col-start-2 lg:col-end-3 lg:text-[18px]'>Hello, I'm
                </motion.p>

                <motion.h1
                    initial={{ opacity: 0, y: 80 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                        ease: [0.6, 0.01, -0.05, 0.95],
                        duration: 1.2,
                        delay: 0.4,
                    }}
                    className='font-syncopate font-bold text-[3.5em] md:text-[4em] xl:text-[5em] leading-[5rem] lg:leading-none lg:text-center lg:col-start-2 lg:col-end-6 w-[100%]'>Rizal Fahadian
                </motion.h1>
                <div className='lg:col-start-2 lg:col-end-6 lg: grid lg:grid-cols-4 items-center'>
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            ease: [0.6, 0.01, -0.05, 0.95],
                            duration: 1,
                            delay: 0.8,
                        }}
                        className='mx-4 font-syncopate md:mx-[7.875em] hidden lg:block lg:mx-0 lg:col-start-1 lg:col-end-2 lg:text-[15px]'>
                        <Tanggal />
                    </motion.div>

                    <motion.p
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            ease: [0.6, 0.01, -0.05, 0.95],
                            duration: 1,
                            delay: 1,
                        }}
                        className='mx-4 md:mx-[7.875em] lg:mx-0 lg:col-start-2 lg:col-end-5 lg:text-[18px]'>I’m a fresh graduate from Universitas Kristen Satya Wacana, currently based in Salatiga, Indonesia. I’m really into UI/UX design, front end development, graphic design & digital illustration.
                    </motion.p>
                </div>
            </main>

            <motion.footer
                initial={{ opacity: 0, y: 180 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 1,
                    delay: 1,
                }}
                className='absolute bottom-0 left-0 right-0 px-4 md:px-[7.875em] flex items-center justify-between  text-center py-8'>
                <img src={rzlfh} alt="rzlfh" className=' hidden md:block animate-spin-slow' />
                <ul className='flex items-center space-x-14 md:space-x-8 text-center  mx-auto md:mx-0'>
                    <li><a href="https://www.instagram.com/rzlfh/" className='underline opacity-70 hover:opacity-100 ' target="_blank">Instagram</a></li>
                    <li><a href="https://www.linkedin.com/in/rizal-fahadian-281b571b1/" className='underline opacity-70 hover:opacity-100' target="_blank">LinkedIn</a></li>
                    <li><a href="https://github.com/rzlfhh" className='underline opacity-70 hover:opacity-100' target="_blank">Github</a></li>
                </ul>
            </motion.footer>
        </>
    )
}

export default Hero
